import slug from 'slug';

export const cleanRuleDescription = (text: string | null) => {
  if (!text) return '';

  // https://github.com/Trott/slug
  slug.charmap[' '] = ' ';

  return slug(text, { lower: false, replacement: ' ' });
};
